import classNames from 'classnames';
import { useLocation, useMatch } from 'react-router-dom';
import { useWizard } from '../../hooks/useWizard';
var Step = function (_a) {
    var path = _a.path, isActive = _a.isActive;
    return (<div className={classNames('h-1 flex-1 rounded-full', isActive ? 'bg-secondary-04' : 'bg-gray-200')}/>);
};
var Progress = function () {
    var location = useLocation();
    var match = useMatch(location.pathname);
    var wizardSteps = useWizard().wizardSteps;
    var activeStep = match === null || match === void 0 ? void 0 : match.pathnameBase;
    return (<div className="flex gap-1.5 max-sm:ml-6 sm:max-lg:ml-20 max-lg:flex-1 lg:col-start-2 lg:col-end-12 xl:max-2xl:ml-8 xl:col-start-3 xl:col-end-11 2xl:col-start-4 2xl:col-end-10">
    {wizardSteps === null || wizardSteps === void 0 ? void 0 : wizardSteps.map(function (step, index) {
            var isActive = activeStep === step;
            return <Step key={index} path={step} isActive={isActive}/>;
        })}
    </div>);
};
export default Progress;
